import React from 'react';
import { CompaniesList } from '../../CompaniesList';

export const BillingCompaniesList = () => <CompaniesList />;
